import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Compass } from "lucide-react";

const links = [
  { to: "/evaluare", label: "Evaluare" },
  { to: "/preturi-zone", label: "Prețuri pe zone" },
  { to: "/comparatie", label: "Comparație" },
  { to: "/preturi", label: "Planuri" },
  { to: "/istoric", label: "Istoric" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  return (
    <header
      data-testid="main-nav"
      className="sticky top-0 z-50 border-b border-[#DEDCCF] backdrop-blur-xl bg-[#F6F4EE]/80"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <div className="w-7 h-7 bg-[#0D1F2D] text-[#F6F4EE] grid place-items-center">
            <Compass size={16} strokeWidth={2.2} />
          </div>
          <div className="leading-none">
            <div className="font-display font-bold text-[17px] tracking-tight">EvalEstate</div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-[#52616B] mono">/ România</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to.replace("/", "")}`}
              className={({ isActive }) =>
                `text-sm hover:text-[#0F6E5B] transition-colors ${isActive ? "text-[#0F6E5B]" : "text-[#0D1F2D]"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <button
            data-testid="nav-cta-evaluate"
            onClick={() => nav("/evaluare")}
            className="bg-[#0D1F2D] hover:bg-[#0F6E5B] transition-colors text-[#F6F4EE] text-sm px-5 h-10 rounded-sm font-medium"
          >
            Evaluează acum →
          </button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden"
          aria-label="Meniu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#DEDCCF] bg-[#F6F4EE]">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-sm py-2">
                {l.label}
              </Link>
            ))}
            <button
              onClick={() => { setOpen(false); nav("/evaluare"); }}
              className="bg-[#0D1F2D] text-[#F6F4EE] text-sm px-5 h-10 rounded-sm font-medium mt-2"
            >
              Evaluează acum →
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
